/** 慢页面追踪 table */
import React from 'react';
import {message, Table} from 'antd';
import api from "../../../lib/api";
import PerformanceDetails from "../../../components/PerformanceDetails";

class ComTable extends React.Component{
  state = {
    scrollY: 560,
    rowData: {},
    showPerformanceDetails: false
  };
  columns = [
    {
      title: '访问页面',
      dataIndex: 'path'
    }, {
      title: '访问时间',
      dataIndex: 'createTime',
      width: 140
    }, {
      title: '页面加载时间',
      dataIndex: 'loadTime',
      render: (val, row) => (
        <span>{row.loadTime} ms</span>
      )
    }, {
      title: '资源加载耗时',
      dataIndex: 'requestTime',
      render: (val, row) => (
        <span>{row.requestTime} ms</span>
      )
    }, {
      title: 'DOM构建耗时',
      dataIndex: 'domCompleteTime',
      render: (val, row) => (
        <span>{row.domCompleteTime} ms</span>
      )
    }, {
      title: '浏览器版本',
      dataIndex: 'browserType',
      width: 150,
      render: (val, row) => (
        <span>{row.browserType}{row.browserVersion}</span>
      )
    }, {
      title: '系统',
      dataIndex: 'systemType',
      width: 70
    }, {
      title: 'IP',
      dataIndex: 'ip',
      width: 120
    }, {
      title: '详情',
      width: 60,
      render: (val, row) => (
        <span className="c-primary cursor-no-select">查看</span>
      )
    },
  ];
  // 获取详情
  getRowData = (row) => {
    api.getVisitInfoDetail(row.id).then(res => {
      if (res.success && res.status === 200) {
        this.setState({
          rowData: res.data || {},
          showPerformanceDetails: true
        });
      } else {
        message.error(res.message);
      }
    })
  };
  // 查看详情 关闭弹窗时清空 rowData， 不然会有缓存问题
  handlePerformanceDetailsCanCel = (boolean) => {
    this.setState({
      showPerformanceDetails: boolean,
      rowData: {}
    })
  };
  UNSAFE_componentWillMount() {
    this.setState({
      scrollY: document.documentElement.clientHeight - 300
    });
    window.onresize= () => {
      this.setState({
        scrollY: document.documentElement.clientHeight - 300
      })
    }
  };
  render() {
    const { tbData, pagination, loading } = this.props;
    const { scrollY, rowData, showPerformanceDetails } = this.state;
    return (
      <div>
        <Table
          onRow={record => {
            return {
              onClick: () => this.getRowData(record) // 点击行
            };
          }}
          className='com-table'
          scroll={{x: 1000, y: scrollY}} rowKey='id' bordered loading={loading} pagination={pagination}
          columns={this.columns} dataSource={tbData} onChange={this.props.pageChange} />
        {
          rowData.id ? <PerformanceDetails rowData={rowData} visible={showPerformanceDetails} onCancel={this.handlePerformanceDetailsCanCel} /> : ''
        }
      </div>
    );
  }
};
export default ComTable;
